export const scoreType = [
    {name: "四川航空金熊猫里程", mark: "scal", image: "/images/scal.png"},
    {name: "厦门航空白鹭积分", mark: "xm_air", image: "/images/xm_air.png"},
    // {name: "中国移动积分", mark: "cmcc", image: "/images/cmcc.png"},
];

export const cmccMoneyList = [
    {
        value: 1,
        score: 180,
        span: 6
    },
    {
        value: 2,
        score: 360,
        span: 6
    },
    {
        value: 5,
        score: 890,
        span: 6
    },
    {
        value: 10,
        score: 1760,
        span: 6
    },
    {
        value: 20,
        score: 3520,
        span: 8
    },
    {
        value: 50,
        score: 8800,
        span: 8
    },
    {
        value: 100,
        score: 17600,
        span: 8
    }
];